/**
 * Area2D property formatter: shows monitoring, monitorable, layer and mask
 * (Godot defaults when the TSCN omits them) ahead of the shared Node2D
 * transform sections.
 */
import { formatNode2DProperties } from '../../../base/node2d/propertyFormatter';
export function formatArea2DProperties(properties) {
    const sections = [
        {
            title: 'Area2D',
            items: [
                { label: 'Monitoring', value: (properties.monitoring ?? true).toString() },
                { label: 'Monitorable', value: (properties.monitorable ?? true).toString() },
                { label: 'Collision Layer', value: (properties.collision_layer ?? 1).toString() },
                { label: 'Collision Mask', value: (properties.collision_mask ?? 1).toString() },
            ],
        },
    ];
    sections.push(...formatNode2DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map